import React from 'react';
import ManagerCTA from 'components/dashboard/ManagerCTA';
import AdminKeyMetrics from 'components/dashboard/admin/AdminKeyMetrics';
import './AdminSummaryDashboard.styl';
import AdminDashSearchSidebar from 'components/dashboard/admin/AdminDashSearchSidebar';
import DashboardV2LoadingOverlay from 'components/manager-dashboard/DashboardV2LoadingOverlay';
import isEqual from 'lodash/isEqual';
import AuthStore from 'stores/AuthStore';
import ManagerDashboardStore from 'stores/ManagerDashboardStore';
import connectToStores from 'alt-utils/lib/connectToStores';
import AccountStore from 'stores/AccountStore';
import moment from 'moment';
import AccountActions from 'actions/AccountActions';
import AdminDashCoachingActivity from 'components/dashboard/admin/AdminDashCoachingActivity';
import CoachingAgendaContainer from 'components/dashboard/CoachingAgendaContainer';
import CoachingQuickReminders from 'components/dashboard/CoachingQuickReminders';
import UpcomingReviewsActions from 'actions/coaching/UpcomingReviewsActions';
import CoachingPlanActions from 'actions/coaching/CoachingPlanActions';
import UPCOMING_REVIEW_ROLES from 'actions/coaching/UPCOMING_REVIEW_ROLES';
import {CTARole} from 'components/dashboard/ManagerCTA.utils';

@connectToStores
export default class AdminSummaryDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      createdDateLoaded: false,
    };
  }

  static getStores() {
    return [AuthStore, ManagerDashboardStore, AccountStore];
  }

  static getPropsFromStores() {
    const widgets = ManagerDashboardStore.getState().get('widgets');
    const accountStore = AccountStore.getState();
    const {report} = widgets.get('admin_key_metrics', {});
    const current = report && report.current;

    const twoWeeksAgo = moment().subtract(2, 'weeks');
    const recentlyMade = twoWeeksAgo.isBefore(accountStore.createdDate);

    return {
      isNewAccount:
        recentlyMade &&
        isEqual(current, {
          averageRepScore: null,
          callVolume: 0,
          durationOfCoaching: 'PT0S',
          numCoachingPlans: 0,
        }),
    };
  }

  componentDidMount() {
    const {adminId} = this.props;

    setTimeout(() => {
      // boy I sure love alt
      AccountActions.fetchCreatedDate().then(() => this.setState({createdDateLoaded: true}));
      // driven by the reviews, but we need plan info too
      CoachingPlanActions.fetchForCoaches([adminId], {
        includeReviews: true,
        includeCompleted: true,
      });
    }, 0);
  }

  render() {
    const {admin, isNewAccount, location} = this.props;
    const {createdDateLoaded} = this.state;

    return (
      <div className="admin-dash-summary">
        <DashboardV2LoadingOverlay />
        <div className="main-content">
          <div className="ctas-container">
            <ManagerCTA {...this.props} role={CTARole.ADMIN} />
          </div>
          {admin && admin.isCoach && (
            <div className="coaching-agenda-wrapper">
              <CoachingQuickReminders location={location} />
              <CoachingAgendaContainer
                {...this.props}
                isNewAccount={createdDateLoaded && isNewAccount}
                hideSuggested
              />
            </div>
          )}
          <div className="key-metrics-container">
            <AdminKeyMetrics {...this.props} />
          </div>
          <div>
            {/** Note: this widget is in charge of showing the new account blurb **/}
            <AdminDashCoachingActivity
              {...this.props}
              isNewAccount={createdDateLoaded && isNewAccount}
              showEffectivenessTag
            />
          </div>
        </div>
        {/* TODO find a way to consolidate with StatsPage2 sidebar*/}
        <AdminDashSearchSidebar
          refreshCoachingData={() => {
            /**
             * Used by
             * @link withCoachingPlanWizard
             */
            /**
             * Consolidate with
             * @link loadUpcomingReviewData
             */
            UpcomingReviewsActions.upcomingReviews.defer(
              admin.id,
              UPCOMING_REVIEW_ROLES.COACH,
              undefined,
              undefined,
              null /* reviewId */
            );
            CoachingPlanActions.fetchForCoaches.defer([admin.id], {
              includeReviews: true,
              includeCompleted: false,
            });
          }}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          fromPath={this.props.fromPath}
          adminId={this.props.adminId}
          hasRenderedDashv2Gif={this.props.hasRenderedDashv2Gif}
          showBlurb={true}
          location={this.props.location}
        />
      </div>
    );
  }
}
